/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Airport_Terminal_DescriptionInputs */

const en_map_airport_terminal_description = /** @type {(inputs: Map_Airport_Terminal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Large airport terminal. Four TinyRobots and two DeliveryRobots, multiple fleets interacting.`)
};

const fr_map_airport_terminal_description = /** @type {(inputs: Map_Airport_Terminal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Grand terminal d'aéroport. Quatre TinyRobot et deux DeliveryRobot, plusieurs flottes en interaction.`)
};

const ms_sg2_map_airport_terminal_description = /** @type {(inputs: Map_Airport_Terminal_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminal lapangan terbang besar. Empat TinyRobot dan dua DeliveryRobot, beberapa armada berinteraksi.`)
};

/**
* | output |
* | --- |
* | "Large airport terminal. Four TinyRobots and two DeliveryRobots, multiple fleets interacting." |
*
* @param {Map_Airport_Terminal_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "ms-SG" }} options
* @returns {LocalizedString}
*/
export const map_airport_terminal_description = /** @type {((inputs?: Map_Airport_Terminal_DescriptionInputs, options?: { locale?: "en" | "fr" | "ms-SG" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Airport_Terminal_DescriptionInputs, { locale?: "en" | "fr" | "ms-SG" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_map_airport_terminal_description(inputs)
	if (locale === "fr") return fr_map_airport_terminal_description(inputs)
	return ms_sg2_map_airport_terminal_description(inputs)
});